var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-baby",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.ae6289c46d6654a14263961c8473e037.svg";
export { ForwardRef as ReactComponent };